import { render, staticRenderFns } from "./AddAccountOrUserToProject.vue?vue&type=template&id=271b1454&scoped=true&"
import script from "./AddAccountOrUserToProject.vue?vue&type=script&lang=js&"
export * from "./AddAccountOrUserToProject.vue?vue&type=script&lang=js&"
import style0 from "./AddAccountOrUserToProject.vue?vue&type=style&index=0&id=271b1454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271b1454",
  null
  
)

export default component.exports